import on from '../util/elements/on'

export default function (Site, $) {
  Site.widget('holiday-times', {
    _create () {
      this.holidayTimes()
    },
    holidayTimes () {
      const tabs = this.element[0].querySelectorAll('.tab')
      const content = this.element[0].querySelectorAll('.tab-content')

      $('.holiday-hours .tab').click( (e) => {
        Object.entries(tabs).forEach(([i, el]) => {
          el.classList.remove('active')
        })

        Object.entries(content).forEach(([i, el]) => {
          el.classList.remove('active')
        })

        e.target.classList.add('active')
        let currentContent = e.target.dataset.for
        document.querySelector('.tab-content[data-target="'+currentContent+'"]').classList.add('active')
      })

    }
  })
}
